export default "__VITE_ASSET__pNNPwKS___"